<template>
  <div
    style="min-width: 1200px"
    class="big"
  >
    <div class="page_title flex_between">
      <span>员工任务详情</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div style="text-align:left">
          <span class="gray">员工号</span>
          <span style="margin-right:50px">{{info.recommender_code}}</span>
          <span class="gray">员工姓名</span>
          <span style="margin-right:50px">{{info.recommender_name}}</span>
          <span class="gray">员工手机号</span>
          <span>{{info.phone}}</span>
        </div>
        <div style="text-align:left;margin:15px 0 20px">
          <span class="gray">任务月份</span>
          <el-date-picker
            v-model="month"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            style=" width: 150px;margin-right:30px"
            @change="changeMonth"
            clearable
          ></el-date-picker>
          <span>
            <span class="gray">任务人数</span>
            <span style="margin-right:50px;color:#FF7430">{{info.auth_doctor_num}}</span>
            <span class="gray">认证通过人数</span>
            <span style="margin-right:50px;color:#FF7430">{{info.auth_count}}</span>
          </span>
        </div>

        <div style="text-align: left;">
          <span>本月已注册/认证医生名单</span>
        </div>

        <div style="border: solid 1px #c9cbd6;margin-top:10px">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1200px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="doctor_name"
              label="医生姓名"
            />
            <el-table-column label="性别">
              <template slot-scope="scope">
                <span v-if="scope.row.sex==1">男</span>
                <span v-if="scope.row.sex==2">女</span>
                <span v-if="scope.row.sex==0">未知</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
            />
            <el-table-column
              prop="title"
              label="职称"
            />
            <el-table-column
              prop="department_name"
              label="科室"
            />
            <el-table-column
              prop="hospital"
              label="医院"
            />
            <el-table-column
              prop="create_time"
              label="注册时间"
            />
            <el-table-column
              prop="first_auth_time"
              label="首次认证通过时间"
            />
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import dayjs from 'dayjs';
import Template from '../../template/Template.vue';
export default {
  components: { Template },
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      info: {},
      month: ''
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.month = this.$route.query.month;
    this.getInfo();
    this.getList();
    // this.getUserList();
  },
  methods: {
    //员工详情
    getInfo() {
      let data = {
        recommender_code: this.$route.query.recommender_code,
        month: this.month
      };
      this.axios
        .post('platform/Activity/getAssignmenInfo', data)
        .then((res) => {
          this.info = res.data.info;
          this.info.auth_doctor_num = this.info.auth_doctor_num
            ? this.info.auth_doctor_num
            : '该月无任务';
        });
    },
    //获取列表
    getList() {
      let data = {
        recommender_code: this.$route.query.recommender_code,
        month: this.month,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/Activity/assignmenDoctorList', data)
        .then((res) => {
          this.totalNum = res.data.total;
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            item.first_auth_time = item.first_auth_time
              ? dayjs.unix(item.first_auth_time).format('YYYY-MM-DD HH:mm')
              : '';
            return item;
          });
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    changeMonth() {
      if (!this.month) {
        this.$message.error('请选择任务月份');
        return false;
      }
      this.getInfo();
      this.getList();
    },
    back() {
      this.$router.push({
        path: 'pullnewdoctor',
        query: {
          month: this.$route.query.month
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  line-height: 32px;
  height: 32px;
  margin-bottom: 20px;
  .box {
    line-height: 32px;
    height: 32px;
    margin-right: 20px;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
.gray {
  color: #747981;
  margin-right: 10px;
}
.itemtitle {
  display: inline-block;
  width: 60px;
  text-align: right;
  margin-right: 10px;
}
</style>



